






























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { CSS, ChannelStyle, menuStyleCSS } from "@/services/styles/types";
import {
    styleComponents,
    styleSufix,
    renderComponents,
    renderSufix
} from "@/components/posts/PostTypeRegister";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import { bus } from "@/bus";
import { settingsValidators } from "@/components/styles/validators";
import validate from "@/directives/validate";
import { validateForm } from "@/services/validation/validationService";
import { createChannelStyle, getChannelStyle, updateChannelStyle } from "@/services/styles/channelStylesService";
import i18n from "@/i18n";
import { ChannelStyleTypes, InteractionTypes } from "@/services/channels/types";
import MenuRender from "@/components/render/MenuRender.vue";

@Component<ChannelStylesForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        ...styleComponents,
        ...renderComponents,
        UnsavedFormModal,
        HeaderActionButtons,
        MenuRender
    },
    filters: {
        style(value: string) {
            if (value === undefined || value === "") return "";
            else {
                return value.concat(styleSufix);
            }
        },
        render(value: string) {
            return value.concat(renderSufix);
        }
    },
    directives: {
        validate
    }
})
export default class ChannelStylesForm extends Vue {
    @Prop() private styleId!: string;

    style = {
        id: "",
        name: "",
        type: ChannelStyleTypes.duration,
        css: {} as CSS
    } as ChannelStyle;

    // used for comparing if form have changes
    priorStyleState = JSON.parse(JSON.stringify(this.style)) as ChannelStyle;

    styleTypeOptions = [
        { name: i18n.t("channelStyles.durationTitle"), id: ChannelStyleTypes.duration },
        { name: i18n.t("channelStyles.counterTitle"), id: ChannelStyleTypes.counter },
        { name: i18n.t("menuStyles.menuStyle"), id: ChannelStyleTypes.menuStyle }
    ];

    localId = this.styleId || "";

    model = {
        id: "",
        width: 600,
        height: 350,
        transitionType: "none",
        interactionType: InteractionTypes.menu,
        returnToFirstPostTime: 5,
        menuCSS: {
            content: "",
            menu: "",
            menuButton: "",
            active: "",
            backBtn: "",
            backBtnArrow: ""
        } as menuStyleCSS,
        transitionTime: 300,
        renderPosts: [
            {
                id: "1",
                name: i18n.t("menuStyles.post") + " 1",
                channelName: i18n.t("navbar.items"),
                channelId: null as null | string,
                postType: "html",
                properties: {
                    html: i18n.t("menuStyles.post") + " 1",
                    showTime: 15
                },
                css: null,
                styleId: ""
            },
            {
                id: "2",
                name: i18n.t("menuStyles.post") + " 2",
                channelName: i18n.t("navbar.items"),
                channelId: null as null | string,
                postType: "html",
                properties: {
                    html: i18n.t("menuStyles.post") + " 2",
                    showTime: 15
                },
                css: null,
                styleId: ""
            },
            {
                id: "3",
                name: i18n.t("menuStyles.post") + " 3",
                channelName: i18n.t("navbar.items"),
                channelId: null as null | string,
                postType: "html",
                properties: {
                    html: i18n.t("menuStyles.post") + " 3",
                    showTime: 15
                },
                css: null,
                styleId: ""
            }
        ],
        danishTime: ""
    }

    menuRenderReload = 0;

    validators = settingsValidators;
    hasText = true;
    channelStyleTypes = ChannelStyleTypes;

    @Watch("style.css", { deep: true }) t() {
        this.cleanFixed();
    }

    nextRoute = "";
    saveClicked = false;
    continue = false;
    fetchingActive = false;
    bgColor = "#ffffff";
    fixedError = false;
    timeout = 0;
    routeParams = {};

    fetchData() {
        if (this.localId) {
            this.fetchingActive = true;
            getChannelStyle(this.localId).then((response: ChannelStyle) => {
                this.style = response;
                bus.$emit("documentTitle", this.style.name);
                this.priorStyleState = JSON.parse(JSON.stringify(this.style));
                if (this.style.type === ChannelStyleTypes.menuStyle) this.model.menuCSS = response.css;
                this.fetchingActive = false;
            });
        }
    }

    // lifecycle hooks
    created() {
        this.initializeStyleId();
        this.fetchData();
    }

    // computed
    get editMode() {
        return !!this.localId;
    }

    // metods
    initializeStyleId() {
        if (!this.localId) {
            this.localId = this.$route.params.styleId;
        }
    }

    setValueData(data: CSS) {
        this.style.css = data;
    }

    cleanFixed() {
        for (const c in this.style.css) {
            if ((this.style.css as any)[c].toLowerCase().includes("fixed")) {
                this.fixedError = true;
                (this.style.css as any)[c] = (this.style.css as any)[c].replace(/fixed/gi, "absolute");
            }
        }
        if (this.fixedError) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.fixedError = false;
            }, 10000);
        }
    }

    clearValue() {
        this.style.css = {} as CSS;
    }

    changePreviewType(value: boolean) {
        this.model.renderPosts.forEach(x => { x.channelId = value ? "123" : null; });
        this.menuRenderReload++;
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const noChanges = this.lodash.isEqual(this.priorStyleState, this.style);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    changeBackground() {
        if (this.bgColor === "#ffffff") this.bgColor = "#999999";
        else this.bgColor = "#ffffff";
    }

    // header buttons
    back() {
        window.history.go(-1);
    }

    // footer buttons
    save(back: boolean) {
        this.saveClicked = true;
        if (!validateForm([this.validators])) return;
        this.cleanFixed();
        if (this.style.type === ChannelStyleTypes.menuStyle) this.style.css = this.model.menuCSS;
        if (!this.editMode) {
            createChannelStyle(this.style).then((id: string) => {
                if (back) this.$router.push({ name: "channelStyles" });
                else {
                    this.localId = id;
                    this.style.id = id;
                    this.priorStyleState.id = id;
                }
            });
        } else {
            updateChannelStyle(this.style).then(() => {
                if (back) this.$router.push({ name: "channelStyles" });
            });
        }
    }
}
